// src/pages/TermsOfService.js
import React from 'react';

const TermsOfService = () => {
  return (
    <div className="p-4 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Terms of Service</h1>
      {/* Add your terms of service content here */}
    </div>
  );
};

export default TermsOfService;
